import { Box, CircularProgress } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';

import Autocomplete from 'shared/components/widgets/autocomplete';
import Input from 'shared/components/widgets/input';

import Button from 'shared/components/widgets/button';
import AutocompleteContainer from 'shared/components/widgets/autocomplete-container';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const EmployeeManagementFilter = ({ getFilteredList, isLoading }) => {
  const location = useLocation()
  const isRefresh = location?.state?.refresh
  const { control, handleSubmit, watch, setValue } = useForm({
    defaultValues: {
      schStaffSt: 'all',
      staffSchGroup: 'sch_name',
      schKeyword: '',
    },
  });

  const employeeStatusFilterData = [
    { label: '전체', value: 'all' },
    { label: '신청', value: '10' },
    { label: '정상', value: '50' },
    { label: '일시정지', value: '80' },
    { label: '퇴사', value: '90' },
  ];

  const searchTargetFilterData = [
    { label: '직원 성명', value: 'sch_name' },
    { label: '직원 이메일', value: 'sch_email' },
    { label: '직원 성명+이메일', value: 'sch_name_email' },
  ];

  useEffect(() => {
    if (isRefresh) {
      setValue('schStaffSt', 'all')
      setValue('staffSchGroup', 'sch_name')
      setValue('schKeyword', '')
    }
  }, [isRefresh])

  const keyword = watch('schKeyword');

  const onSubmit = (data) => {
    const { schStaffSt, staffSchGroup, schKeyword } = data;
    getFilteredList([
      { key: 'page', value: 1 },
      {
        key: 'schStaffSt',
        value: schStaffSt === 'all' ? '' : schStaffSt,
      },
      { key: 'staffSchGroup', value: staffSchGroup },
      { key: 'schKeyword', value: schKeyword },
    ]);
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      display="flex"
      flexDirection="row"
      alignItems="flex-end"
      gap={3}
      marginBottom="40px"
    >
      {/* EMPLOYEE STATUS */}
      <AutocompleteContainer>
        <Controller
          name="schStaffSt"
          control={control}
          render={({ field }) => {
            return (
              <Autocomplete
                {...field}
                title="직원 상태"
                options={employeeStatusFilterData}
                defaultValue={
                  employeeStatusFilterData.find(
                    (el) => el.value === field.value,
                  ) ?? {
                    label: '전체',
                    value: 'all',
                  }
                }
                value={field?.value ?? 'all'}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                onChange={(_, newValue, reason) => {
                  field.onChange(newValue?.value);
                  if (reason === 'clear') {
                    field.onChange('all');
                  }
                }}
              />
            );
          }}
        />
      </AutocompleteContainer>
      {/* EMPLOYEE SEARCH TARGET */}
      <AutocompleteContainer>
        <Controller
          name="staffSchGroup"
          control={control}
          render={({ field }) => {
            return (
              <Autocomplete
                {...field}
                title="검색어 대상"
                options={searchTargetFilterData}
                defaultValue={
                  searchTargetFilterData.find(
                    (el) => el.value === field.value,
                  ) ?? {
                    label: '직원 성명',
                    value: 'sch_name',
                  }
                }
                value={field?.value ?? 'sch_name'}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                onChange={(_, newValue, reason) => {
                  field.onChange(newValue?.value);
                  if (reason === 'clear') {
                    field.onChange('sch_name');
                  }
                }}
              />
            );
          }}
        />
      </AutocompleteContainer>
      {/* SEARCH TERM TARGET */}
      <Box flex={1}>
        <Controller
          name="schKeyword"
          control={control}
          render={({ field }) => {
            return (
              <Input
                {...field}
                isSearch
                keyword={keyword}
                placeholder="검색어를 입력해 주세요."
                clearAction={() => {
                  field.onChange('');
                }}
                value={field.value}
                showErrorMsg={false}
              />
            );
          }}
        />
      </Box>
      <Button
        disabled={isLoading}
        variant="outlined"
        type="submit">
        {isLoading ?
          <CircularProgress size={20} color='secondary' />
          :
          '검색하기'
        }
      </Button>
    </Box>
  );
};

export default EmployeeManagementFilter;
